var map = {
	"./2.jpeg": 4068,
	"./3.jpeg": 4311,
	"./4.jpeg": 3545,
	"./5.jpeg": 2101,
	"./6.jpeg": 153,
	"pages/LandingPage/sections/LandingPageGallerySection/images/2.jpeg": 4068,
	"pages/LandingPage/sections/LandingPageGallerySection/images/3.jpeg": 4311,
	"pages/LandingPage/sections/LandingPageGallerySection/images/4.jpeg": 3545,
	"pages/LandingPage/sections/LandingPageGallerySection/images/5.jpeg": 2101,
	"pages/LandingPage/sections/LandingPageGallerySection/images/6.jpeg": 153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7215;